import React from 'react';
import { TextField } from '@mui/material';

const TextareaWrapper = ({ field, value, onChange, error }) => {
  return (
    <TextField
      fullWidth
      multiline
      rows={4}
      name={field.name}
      label={field.label}
      value={value}
      onChange={(e) => onChange(field.name, e.target.value)}
      error={!!error}
      helperText={error || ''}
      margin="normal"
    />
  );
};

export default TextareaWrapper;
